const videoHeader = document.querySelector('.hero__background--video, .header__video');
if (videoHeader) {
    if (window.matchMedia('(min-width: 720px)').matches) {
        videoHeader.src = videoHeader.dataset.srcLandscape;
    } else {
        videoHeader.src = videoHeader.dataset.srcPortrait;
    }

    videoHeader.load();
}

const heroVideoContainer = document.querySelector('.hero-video');
const heroVideo = document.querySelector('.hero-video__frame');

const heroVideoPlayButton = document.getElementById('hero-video-play-button');
const heroVideoCloseButton = document.getElementById('hero-video-close-button');

if (heroVideoPlayButton) {
    heroVideoPlayButton.addEventListener('click', () => {
        heroVideoContainer.hidden = false;
        heroVideo.play();
        heroVideo.focus();
    });
}

if (heroVideoCloseButton) {
    heroVideoCloseButton.addEventListener('click', () => {
        heroVideoContainer.hidden = true;
        heroVideo.pause();
        heroVideoPlayButton.focus();
    });
}

if (heroVideoContainer) {
    document.onkeydown = e => {
        if (e.key === 'Escape' || e.key === 'Esc') {
            heroVideoContainer.hidden = true;
            heroVideo.pause();
            heroVideoPlayButton.focus();
        }
    };
}
